import NotFoundPage from "./not-found";
export default NotFoundPage;
